import PropTypes from 'prop-types';
import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';

import {
  getLocalStorageItem,
  setLocalStorageItem,
} from '../../../utils/localStorage';
import { setSessionStorageItem } from '../../../utils/sessionStorage';
import CircularLoading from '../../Common/CircularLoading/CircularLoading';
import { Desktop } from '../../Common/const';
import PfeSktSwitch from '../../Common/PfeSktSwitch/PfeSktSwitch';
import StudyList from '../../StudyList/StudyList';
import StudyAppPopUp from '../StudyAppPopUp/StudyAppPopUpView';
import StudyFavoriteQuestions from './StudyFavoriteQuestions';
import StudySubmittedQuestions from './StudySubmittedQuestions';
import SubscriptionWarningModal from './SubscriptionWarningModal';

class StudyMain extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAppModal: false,
      isSubscriptionWarningModalOpen: false,
      hasSeenSubscriptionWarningModal: false,
      switchPfeSktWaiting: false,
    };
  }

  componentDidMount() {
    if (this.props.user) {
      this.initialReferencesFetch();
    }
    if (
      this.props.counterSubmitted &&
      Object.entries(this.props.counterSubmitted).length === 0
    ) {
      this.props.getSubmittedQuestions();
    }

    window.scrollTo(0, 0);
    this.props.setBackTo('/app/study');
    setSessionStorageItem('nextUpType', 'references');
    const showAppModal = getLocalStorageItem('appModal');
    if (!showAppModal) {
      this.setState({
        showAppModal: true,
      });
    }
    if (this.props.breadcrumsQualsAndCertsAction) {
      this.props.breadcrumsQualsAndCertsAction('');
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.user !== this.props.user) {
      this.initialReferencesFetch();
    }
    if (
      Object.keys(this.props.user).length > 0 &&
      !this.props.user.stripeId &&
      !this.props.user.transactionIosId &&
      !this.props.user.isGuestAccount &&
      !this.state.isSubscriptionWarningModalOpen &&
      !this.state.hasSeenSubscriptionWarningModal
    ) {
      this.setState({
        isSubscriptionWarningModalOpen: true,
        hasSeenSubscriptionWarningModal: true,
      });
    }
    // Open reference or chapter pdf when link is received from API
    if (prevProps.pdfLink !== this.props.pdfLink) {
      window.open(this.props.pdfLink.url);
    }

    // Open the generated Post Exam Checklist pdf when it's ready
    if (
      prevProps.postExamChecklistPdfLink !== this.props.postExamChecklistPdfLink
    ) {
      this.openPostExamChecklistPdf(this.props.postExamChecklistPdfLink.url);
    } else if (
      prevProps.isLoadingPostExamChecklistPdf &&
      !this.props.isLoadingPostExamChecklistPdf
    ) {
      // Generation failed: close the placeholder tab opened on click
      this.closePostExamChecklistWindow();
    }

    if (prevProps.switchPfeSktWaiting !== this.props.switchPfeSktWaiting) {
      this.setState({
        switchPfeSktWaiting: this.props.switchPfeSktWaiting,
      });
    }
  }

  componentWillUnmount() {
    this.closePostExamChecklistWindow();
  }

  initialReferencesFetch = () => {
    const {
      user,
      pfeSktId,
      contentByReferenceFetched,
      contentByReferenceFetching,
    } = this.props;

    if (!user || !pfeSktId) return;

    // Skip if already fetched or currently fetching
    if (contentByReferenceFetched || contentByReferenceFetching) return;

    const rate = pfeSktId === user.pfeRate.id ? user.pfeRate : user.rate;
    if (!rate) return;

    this.props.getByReference(rate);
  };

  toggleAppModalState = () => {
    const expireTime = 24 * 60 * 60 * 1000;
    this.setState(
      {
        showAppModal: !this.state.showAppModal,
      },
      () => {
        setLocalStorageItem('appModal', this.state.showAppModal, expireTime);
      },
    );
  };

  setQuestionNotification = (id) => {
    this.props.setQuestionNotification(id, 'chapter');
  };

  handlePostExamChecklistClick = () => {
    // Generating the pdf (more chapters on SKT) can take longer than the
    // browser's user-activation window, after which window.open is blocked as
    // a popup. Open the tab synchronously on click and navigate it later.
    this.closePostExamChecklistWindow();
    this.postExamChecklistWindow = window.open('', '_blank');
    if (this.postExamChecklistWindow) {
      const { document: placeholderDoc } = this.postExamChecklistWindow;
      placeholderDoc.title = 'Post Exam Checklist';
      placeholderDoc.documentElement.style.overflow = 'hidden';
      placeholderDoc.body.style.margin = '0';
      placeholderDoc.body.style.overflow = 'hidden';
      placeholderDoc.body.innerHTML =
        '<main style="min-height:100vh;display:flex;align-items:center;' +
        'justify-content:center;margin:0;padding:1rem;box-sizing:border-box;' +
        'background:#f5f7fa;font-family:Helvetica,Arial,sans-serif;' +
        'color:#151b4f;text-align:center">' +
        '<p style="margin:0;font-size:22px;font-weight:600;line-height:1.4">' +
        'Generating your Post Exam Checklist, please wait...</p></main>';
    }
    this.props.getPostExamChecklistPdf();
  };

  openPostExamChecklistPdf = (url) => {
    if (!url) {
      this.closePostExamChecklistWindow();
      return;
    }
    if (this.postExamChecklistWindow && !this.postExamChecklistWindow.closed) {
      this.postExamChecklistWindow.location.href = url;
    } else {
      window.open(url, '_blank');
    }
    this.postExamChecklistWindow = null;
  };

  closePostExamChecklistWindow = () => {
    if (this.postExamChecklistWindow && !this.postExamChecklistWindow.closed) {
      this.postExamChecklistWindow.close();
    }
    this.postExamChecklistWindow = null;
  };

  renderFavoriteQuestions() {
    return (
      <div>
        <StudyFavoriteQuestions
          history={this.props.history}
          counterFavorite={this.props.counterMyFavorite}
        />
        <StudyFavoriteQuestions
          history={this.props.history}
          counterFavorite={this.props.counterFavorite}
          otherUsersQuestions
        />
      </div>
    );
  }

  renderSubmittedQuestions(isSkt) {
    return (
      <div>
        <h4>
          Submitted <span>{isSkt ? 'SKT' : 'PFE'}</span> questions
        </h4>
        <StudySubmittedQuestions
          history={this.props.history}
          counterSubmitted={this.props.counterMySubmitted}
        />
        <StudySubmittedQuestions
          history={this.props.history}
          counterSubmitted={this.props.counterSubmitted}
          otherUsersQuestions
        />
      </div>
    );
  }

  renderReferences(isSkt) {
    return (
      <>
        <h4 id="references">
          By <span>{isSkt ? 'SKT' : 'PFE'}</span> Reference
        </h4>
        {window.innerWidth <= 720 && (
          <StudyAppPopUp
            isOpen={this.state.showAppModal}
            closeFunction={this.toggleAppModalState}
          />
        )}
        <StudyList
          user={this.props.user}
          userSubscription={this.props.userSubscription}
          setQuestionNotification={this.setQuestionNotification}
          items={this.props.contentByRef}
          location={this.props.location}
          setChapterId={this.props.setChapterId}
          getPdfByReference={this.props.getPdfByReference}
          activateSubscription={this.props.activateSubscription}
          subscriptionActivationSucces={this.props.subscriptionActivationSucces}
          subscriptionActivationWaiting={
            this.props.subscriptionActivationWaiting
          }
          subscriptionActivationMessage={
            this.props.subscriptionActivationMessage
          }
          pdfLink={this.props.pdfLink.url}
          setIsStudyingSubmittedQuestions={
            this.props.setIsStudyingSubmittedQuestions
          }
          setIsStudyingFavoriteQuestions={
            this.props.setIsStudyingFavoriteQuestions
          }
          setIsStudyingMyFavoriteQuestions={
            this.props.setIsStudyingMyFavoriteQuestions
          }
          setIsStudyingMySubmittedQuestions={
            this.props.setIsStudyingMySubmittedQuestions
          }
          updateDisabledChapter={this.props.updateDisabledChapter}
          getAudioPlaylist={this.props.getAudioPlaylist}
          audioPlaylist={this.props.audioPlaylist}
          audioPlaylistsProgress={this.props.audioPlaylistsProgress}
          audioPlaylistsProgressFetched={
            this.props.audioPlaylistsProgressFetched
          }
          audioPlaylistsProgressFetching={
            this.props.audioPlaylistsProgressFetching
          }
          getAudioPlaylistsProgress={this.props.getAudioPlaylistsProgress}
          updateAudioPlaylistProgress={this.props.updateAudioPlaylistProgress}
        />
      </>
    );
  }

  renderPostExamChecklistRow(isSkt, hasFavoriteQuestions) {
    return (
      <div className="d-flex align-items-center post-exam-checklist-row">
        {hasFavoriteQuestions ? (
          <h4 className="mb-0">
            My Favorite <span>{isSkt ? 'SKT' : 'PFE'}</span> questions
          </h4>
        ) : null}
        <button
          type="button"
          id="post-exam-checklist-btn"
          className="btn btn-outline-primary ml-auto post-exam-checklist-btn"
          onClick={this.handlePostExamChecklistClick}
          disabled={this.props.isLoadingPostExamChecklistPdf}
        >
          {this.props.isLoadingPostExamChecklistPdf
            ? 'GENERATING...'
            : 'POST EXAM CHECKLIST'}
        </button>
        <Desktop>
          <UncontrolledTooltip placement="top" target="post-exam-checklist-btn">
            Prints a paper checklist of your required chapters to rate your
            confidence after the test.
          </UncontrolledTooltip>
        </Desktop>
      </div>
    );
  }

  renderBody(renderPfeOrSkt) {
    const hasFavoriteQuestions =
      this.props.counterFavorite &&
      Object.keys(this.props.counterFavorite).length > 0 &&
      this.props.counterMyFavorite &&
      Object.keys(this.props.counterMyFavorite).length > 0;

    return (
      <div className="pt-3 px-2 px-sm-0 px-md-3">
        {this.renderPostExamChecklistRow(renderPfeOrSkt, hasFavoriteQuestions)}
        {hasFavoriteQuestions && <div>{this.renderFavoriteQuestions()}</div>}
        {this.props.counterSubmitted &&
          Object.keys(this.props.counterSubmitted).length > 0 &&
          this.props.counterMySubmitted &&
          Object.keys(this.props.counterMySubmitted).length > 0 && (
            <div>{this.renderSubmittedQuestions(renderPfeOrSkt)}</div>
          )}
        {this.props.contentByRef !== undefined &&
        this.props.userSubscription ? (
          <div>{this.renderReferences(renderPfeOrSkt)}</div>
        ) : (
          <CircularLoading />
        )}
      </div>
    );
  }

  handleSwitchClick = (tab) => {
    const { rate, pfeRate } = this.props.user;
    const isSkt = tab === 'SKT';
    this.setState({ switchPfeSktWaiting: true });
    setTimeout(() => {
      this.props.setSwitchPfeSkt(isSkt ? rate.id : pfeRate.id);
      this.props.getByReference(isSkt ? rate : pfeRate);
    }, 1000);
  };

  render() {
    const renderPfeOrSkt = !this.props?.user?.rate?.isPfeOnly
      ? this.props?.pfeSktId === this.props?.user?.rate?.id
      : false;
    return (
      <div>
        {this.state.isSubscriptionWarningModalOpen && (
          <SubscriptionWarningModal
            isOpen={this.state.isSubscriptionWarningModalOpen}
            toggle={() =>
              this.setState({
                isSubscriptionWarningModalOpen:
                  !this.state.isSubscriptionWarningModalOpen,
              })
            }
          />
        )}
        <div className="study-main-body">
          {this.props.location.pathname === '/app/study' && (
            <>
              {this.props?.userSubscription && (
                <div className="pt-3 px-2 px-sm-0 px-md-3">
                  <h4>What do you want to study?</h4>
                  <PfeSktSwitch
                    activeTab={renderPfeOrSkt ? 'SKT' : 'PFE'}
                    onSwitch={this.handleSwitchClick}
                    variant="segmented"
                    size="lg"
                    sktLocked={
                      !this.props?.userSubscription?.isOccupational ||
                      this.props?.user?.rate?.isPfeOnly
                    }
                    labels={{ pfe: 'PFE Content', skt: 'SKT Content' }}
                  />
                </div>
              )}

              <div>
                {this.props.userSubscription &&
                !this.state.switchPfeSktWaiting ? (
                  <div className="options-study-references">
                    {this.props.userSubscription.isOccupational &&
                    !this.props.isLoadingReferences ? (
                      !this.props.isLoadingReferences ? (
                        this.renderBody(renderPfeOrSkt)
                      ) : (
                        <CircularLoading />
                      )
                    ) : // PFE ONLY
                    !this.props.isLoadingReferences ? (
                      this.renderBody(renderPfeOrSkt)
                    ) : (
                      <CircularLoading />
                    )}
                  </div>
                ) : (
                  <div>
                    {!this.props.userSubscription && <CircularLoading />}
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

StudyMain.propTypes = {
  getByReference: PropTypes.func.isRequired,
  getByWarfareQuals: PropTypes.func.isRequired,
};

export default StudyMain;
